import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';
import { PrivacyAcceptanceApi } from './PersonPrivacyAcceptanceApi';

/**
 * APIL Url: ADAC.Internet.Types.Person.Privacy
 * 
 * Endpoints: /api/Identity, /api/MeineDaten/UpdateOptIn, /api/MeineDaten/OptInGenerierung, /api/versicherungen/us/pruefen
 */
export class PrivacyApi extends BaseApiModel {
	constructor(initialProperties?: Partial<PrivacyApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected einwilligung: PrivacyAcceptanceApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.PrivacyAcceptance
	 */
	get Einwilligung(): PrivacyAcceptanceApi {
		return this.einwilligung;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.PrivacyAcceptance
	 */
	set Einwilligung(value: PrivacyAcceptanceApi) {
		this.einwilligung = value;
	}

	protected keineAblehnung: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get KeineAblehnung(): boolean {
		return this.keineAblehnung;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set KeineAblehnung(value: boolean) {
		this.keineAblehnung = value;
	}

	protected print: PrivacyAcceptanceApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.PrivacyAcceptance
	 */
	get Print(): PrivacyAcceptanceApi {
		return this.print;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.PrivacyAcceptance
	 */
	set Print(value: PrivacyAcceptanceApi) {
		this.print = value;
	}

	protected email: PrivacyAcceptanceApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.PrivacyAcceptance
	 */
	get Email(): PrivacyAcceptanceApi {
		return this.email;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.PrivacyAcceptance
	 */
	set Email(value: PrivacyAcceptanceApi) {
		this.email = value;
	}

	protected telefon: PrivacyAcceptanceApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.PrivacyAcceptance
	 */
	get Telefon(): PrivacyAcceptanceApi {
		return this.telefon;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.PrivacyAcceptance
	 */
	set Telefon(value: PrivacyAcceptanceApi) {
		this.telefon = value;
	}

	protected emailadresse: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get Emailadresse(): string {
		return this.emailadresse;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set Emailadresse(value: string) {
		this.emailadresse = value;
	}

	protected version: number;
	/**
	 * Description: 
	 * APIL Type: int32
	 */
	get Version(): number {
		return this.version;
	}

	/**
	 * Description: 
	 * APIL Type: int32
	 */
	set Version(value: number) {
		this.version = value;
	}

	protected timeStamp: string;
	/**
	 * Description: 
	 * APIL Type: date-time
	 */
	get TimeStamp(): string {
		return this.timeStamp;
	}

	/**
	 * Description: 
	 * APIL Type: date-time
	 */
	set TimeStamp(value: string) {
		this.timeStamp = value;
	}

	protected herkunftsKnz: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get HerkunftsKnz(): string {
		return this.herkunftsKnz;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set HerkunftsKnz(value: string) {
		this.herkunftsKnz = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): PrivacyApi {
		return AppUtils.Helper.createFromMap(dataObject, PrivacyApi, (key, value) => {
			switch (key.toLowerCase()) {

				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.Einwilligung = this.einwilligung;
		result.KeineAblehnung = this.keineAblehnung;
		result.Print = this.print;
		result.Email = this.email;
		result.Telefon = this.telefon;
		result.Emailadresse = this.emailadresse;
		result.Version = this.version;
		result.TimeStamp = this.timeStamp;
		result.HerkunftsKnz = this.herkunftsKnz;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}